import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { EntityHeaderBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { CatalogIndexPageWithUrlSync } from '../../components/catalog/CatalogIndexPageWithUrlSync';
import { LegacyEntityHeader } from '../../components/catalog/LegacyEntityHeader';

// Registering any legacy entity header keeps the entity page on the wave-style
// MUI layout instead of the BUI header introduced in plugin-catalog 2.0.7.
const legacyEntityHeader = EntityHeaderBlueprint.make({
  name: 'legacy',
  params: {
    loader: async () => <LegacyEntityHeader />,
  },
});

export const catalogPluginOverride = catalogPlugin.withOverrides({
  extensions: [
    legacyEntityHeader,
    catalogPlugin.getExtension('page:catalog').override({
      params: {
        path: '/catalog',
        noHeader: true,
        loader: async () => (
          <CatalogIndexPageWithUrlSync
            exportSettings={{
              enabled: true,
              columns: [
                { entityFilterKey: 'metadata.name', title: 'Name' },
                { entityFilterKey: 'spec.system', title: 'System' },
                { entityFilterKey: 'spec.owner', title: 'Owner' },
                { entityFilterKey: 'spec.type', title: 'Type' },
                { entityFilterKey: 'spec.lifecycle', title: 'Lifecycle' },
                {
                  entityFilterKey: 'metadata.description',
                  title: 'Description',
                },
              ],
            }}
          />
        ),
      },
    }),
  ],
});